import React, { useContext, useEffect, useMemo, useState } from 'react';

// Types.
import InstanceTarget from '../../../types/instance/InstanceTarget';

// Helpers.
import {
    fetchResults,

    mergeArraysByProp,
    stringFormatting,
    timeSeriesWithGranularity
} from "../../../helpers/utils";
import SqlApi from "../../../api/instance/SqlApi";
import { showError } from '../../../utils/showAlert';
import Helper from "../../../helpers/Helper";
import { useLocation, useNavigate } from 'react-router-dom';
import ConditionalRender from "../../../helpers/ConditionalRender";
import { Dropdown } from "../../../components/forms";
import { CHART_TYPE_OPTIONS } from "../../../component/Constants";
import * as QueryString from "query-string";

// Oracle.
import OracleStatisticsTable from "./oracle-statistics-table";


//Constants
import {
    CHART_DATA_TYPE,
    OTHER_COLOUR_CODE,
    TARGET_COLOUR_CODES
} from "../../../component/Constants";

//style
import './styles.scss'
import { OracleSqlHashTimeSlice, OracleSqlHashWithMetric } from "../types"
import { InstanceContext } from "../../../context/InstanceContext";
import TimeSeriesChart from "../../../component/chart/echarts/TimeSeriesChart";
import { EChartPoint, EChartTimeSeries } from "../../../component/chart/echarts/types";
import { TimeRangeContext } from "../../../context/TimeRangeContext";
import { buildApiQuery } from "../../../helpers/timeRangeUtils";

const UPMOST_CHART_INDEX_VALUE = 99999

export default function OracleStatistics(props: {
    metricsList: string[];
    setInstanceType: Function;
    type: string;
}) {

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const { instances } = useContext(InstanceContext);
    instances.sort((a, b) => a.name.localeCompare(b.name))

    const [instanceId, setInstanceId] = useState<number>(parseInt(searchParams.get('instance') || '', 10) || -1)
    const [filter] = useState<string>(searchParams.get('filter') || '')
    // const [aggregate, setAggregate] = useState<number>(parseInt(searchParams.get('aggregate') || '0'));
    const [metric, setMetric] = useState<string>(searchParams.get('metric') || '');
    // const [defaultTimeSlice, setDefaultTimeSlice] = useState<number>(INTERVAL_10_SECONDS);
    const [generateEnabled, setGenerateEnabled] = useState<boolean>(false);
    const [chartVisible, setChartVisible] = useState<boolean>(true);
    const [metricsList, setMetricsList] = useState<string[]>([]);
    const [statementsApiData, setStatementsApiData] = useState<any[]>([])
    const [chart, setChart] = useState<string>(searchParams.get('chart') || 'column');
    const [topN, setTopN] = useState<number>(searchParams.get('topN') ? parseInt(searchParams.get('topN') as string) : 10);
    const [other, setOther] = useState<boolean>(searchParams.get('other') === 'true');
    const [topNChartData, setTopNChartData] = useState<{
        [key: string]: { values: OracleSqlHashTimeSlice[], orderIndex: number }
    }>({});
    const [tagName, setTagName] = useState<string>(searchParams.get('tagName') || 'none');
    const [generateId, setGenerateId] = useState<number>(1);
    const [tagList, setTagList] = useState<any[]>([]);
    const tagValue = searchParams.get('tagValue') || ''
    const [customSqlId, setCustomSqlID] = useState<string>(searchParams.get('customId') || searchParams.get('filter') || '')
    const [loading, setLoading] = useState<boolean>(false);

    const [generatedTagName, setGeneratedTagName] = useState<string>('none')
    const [generatedTagValue, setGeneratedTagValue] = useState<string>('')
    const [generatedSqlId, setGeneratedSQlId] = useState<boolean>(searchParams.get('showSqlId') === 'true');
    const [generatedMetric, setGeneratedMetric] = useState<string>(searchParams.get('metric') || '')
    const [generatedCustomId, setGeneratedCustomId] = useState<string>(searchParams.get('customId') || '')
    const [generatedInstance, setGeneratedInstance] = useState<InstanceTarget | null>(null)
    const navigate = useNavigate();
    const timeRangeContext = useContext(TimeRangeContext)

    const availableInstances = useMemo(() => {
        return instances
                .filter((instance: InstanceTarget) => instance.collectsqlstatistics)
                .sort((a, b) => a.name.localeCompare(b.name));
    }, [instances]);

    const instanceType = availableInstances.find(instance => instance.id === instanceId)?.type
    const [sqlId, setSQlId] = useState<boolean>(searchParams.get('showSqlId') === 'true');


    const updateUrlParams = (type: string, value: string, isDelete?: boolean) => {
        const query = window.location.search;
        let queryString = QueryString.parse(query);
        if (isDelete) {
            delete queryString[type]
        } else {
            queryString[type] = value
        }
        navigate(`?${QueryString.stringify(queryString)}`)
    }

    const deleteUrlParam = (type: string) => {
        const query = window.location.search;
        let params = QueryString.parse(query);
        delete params[type]
        navigate(`?${QueryString.stringify(params)}`)
    }

    useEffect(() => {
        setTagName(searchParams.get('tagName') || 'none')
    }, [tagList, timeRangeContext.timeRange.from.valueOf(), timeRangeContext.timeRange.to.valueOf(), timeRangeContext.timeRange.interval])


    useEffect(() => {
        const list = props.metricsList
        setMetricsList(list)
        const selectedMetric = searchParams.get('metric')
        let newMetric = ''
        if (list.length && selectedMetric) {
            newMetric = list.indexOf(selectedMetric) > -1 ? selectedMetric : ''
            setMetric(newMetric)
        }

    }, [instanceId, timeRangeContext.timeRange.from.valueOf(), timeRangeContext.timeRange.to.valueOf(), timeRangeContext.timeRange.interval, props.metricsList])


    const __getOtherTotal = (allMetrics: any, topNMetrics: any): OracleSqlHashTimeSlice => {
        let totalValue = allMetrics[metric]
        topNMetrics.forEach((item: any) => {
            const getTopNItemAtTimeSlice = item.find((x: OracleSqlHashTimeSlice) => x.timeslice === allMetrics.timeslice) || 0
            totalValue = getTopNItemAtTimeSlice[metric] ? totalValue - getTopNItemAtTimeSlice[metric] : totalValue
        })
        return {
            timeslice: allMetrics.timeslice,
            [metric]: totalValue < 0 ? 0 : totalValue
        }
    }

    const selectedInstanceTarget = useMemo(() => {
        // const getInstance = instances.find(instance => instance.id === instanceId)
        // const getTimeSliceValue = getInstance?.batchintervalseconds ? getInstance?.batchintervalseconds * 1000 : INTERVAL_10_SECONDS
        // setDefaultTimeSlice(getTimeSliceValue)
        return instances.find((instance: InstanceTarget) => instance.id === instanceId) || null
    }, [instanceId])

    useEffect(() => {
        setGenerateEnabled(!!(topN && metric && instanceId && (filter ? customSqlId : true)))
    }, [topN, metric, instanceId, customSqlId])

    useEffect(() => {
        async function gettagNames() {
            let gettagNames: any = []
            gettagNames = await fetchResults([SqlApi.fetchTagName(instanceId)])
            setTagList(gettagNames[0])
        }

        gettagNames()

        // set instance type to get list of metrics for it
        if (instanceType) {
            props.setInstanceType(instanceType)
        }
    }, [instanceId])

    useEffect(() => {
        if (instanceId && metric && topN) {
            load()
        }
    }, []);

    useEffect(() => {
        if (topN < 1) {
            return setTopN(1)
        }
        if (topN > 100) {
            return setTopN(100)
        }
    }, [topN])

    async function load() {
        setGenerateId(new Date().getTime())
        try {
            let chartApiDataResults: OracleSqlHashWithMetric[][] = [[]]
            const instanceType = availableInstances.find(instance => instance.id === instanceId)?.type || 'oracle'

            // let groupStatementsData: OracleSqlHashWithMetric[][] = [];
            if (!loading && metric && chart && instanceId) {
                setLoading(true);
                let topNChartApiDataResults: OracleSqlHashWithMetric[] = []
                if (filter) {
                    const apiString = sqlId ? `&sqlid=${customSqlId}` : `&sqlhash=${customSqlId}`
                    chartApiDataResults = await fetchResults([
                        tagName === 'none'
                            ? SqlApi.fetchStatisticSql(buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType, `&sort=${metric}+desc${apiString}`)
                            : SqlApi.fetchStatisticTagValue(tagName, buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType, `&sort=${metric}+desc${apiString}`)
                    ])
                }
                if (!filter && !tagValue) {
                    let apiString = ''
                    if (customSqlId) {
                        apiString = sqlId ? `&sqlid=${customSqlId}` : `&sqlhash=${customSqlId}`
                    }
                    chartApiDataResults = await fetchResults([
                        tagName === 'none'
                            ? SqlApi.fetchStatisticSql(buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType, `&sort=${metric}+desc${apiString}`)
                            : SqlApi.fetchStatisticTagValue(tagName, buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType, `&sort=${metric}+desc${apiString}`)
                    ])
                }
                if (tagValue) {
                    chartApiDataResults = await fetchResults([SqlApi.fetchStatisticSql(buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType, `&sort=${metric}+desc&tagvalue=${tagValue}&tagname=${tagName}`)])
                }
                let secondSortOption = tagName !== 'none' ? 'tagvalue' : 'sqlhash'
                const sortedResults = chartApiDataResults[0].sort((a: any, b: any) => {
                    return (b[metric] - a[metric]) || b[secondSortOption]?.localeCompare(a[secondSortOption])
                })

                topNChartApiDataResults = sortedResults.slice(0, topN)


                let topNChartTimePromises = []
                for (let sqlHashData of topNChartApiDataResults) {
                    const apiSqlHash = (tagName === 'none' || filter || tagValue) ? `sqlhash=${sqlHashData.sqlhash}` : `tagname=${tagName}&tagvalue=${sqlHashData.tagvalue}`
                    topNChartTimePromises.push(SqlApi.fetchStatisticTime(buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType, `&${apiSqlHash}&limit=50000&component=OracleStatistics`))
                }

                const topNChartTimeResults = await fetchResults(topNChartTimePromises)

                let allChartTimeResults: OracleSqlHashTimeSlice[][] = []
                if (other) {
                    allChartTimeResults = await fetchResults([SqlApi.fetchStatisticTime(buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType, '&limit=50000&component=OracleStatistics')]);  // add tag name?
                }


                const topNData: { [key: string]: { values: OracleSqlHashTimeSlice[], orderIndex: number } } = {}

                topNChartTimeResults.forEach((result: OracleSqlHashTimeSlice[], index: number) => {
                    const sqlhash = (tagName !== 'none' && !tagValue) ? topNChartApiDataResults[index].tagvalue : (sqlId && topNChartApiDataResults[index].sqlid) ? topNChartApiDataResults[index].sqlid : topNChartApiDataResults[index].sqlhash

                    if (sqlhash) {
                        topNData[sqlhash] = {
                            values: result.map((item: any) => {
                                return {
                                    timeslice: item.timeslice,
                                    [metric]: item[metric],
                                }
                            }),
                            orderIndex: index + 1
                        }
                    }
                    if (other) {
                        const otherValues = result.map((item: OracleSqlHashTimeSlice) => {
                            const getAllAtTimeSlice = allChartTimeResults[0].find((otherItem: OracleSqlHashTimeSlice) => otherItem.timeslice === item.timeslice)
                            if (getAllAtTimeSlice) {
                                const otherTotal = __getOtherTotal(getAllAtTimeSlice, topNChartTimeResults)
                                const valuesExist = topNData['Other SQL']?.values?.find(item => item.timeslice === otherTotal.timeslice)
                                // return topNData['Other SQL']?.values.find(item => item.timeslice === otherTotal.timeslice) ? [] : otherTotal
                                return valuesExist || otherTotal
                            }
                            return []
                        })
                        topNData['Other SQL'] = {
                            // @ts-ignore
                            // values:  topNData['Other SQL']?.values.length ? topNData['Other SQL']?.values.concat(otherValues) : otherValues,
                            values: topNData?.['Other SQL']?.values ? mergeArraysByProp(topNData?.['Other SQL']?.values, otherValues, 'timeslice') : otherValues,
                            orderIndex: UPMOST_CHART_INDEX_VALUE
                        }
                    }
                })

                // Fill missing data with 0 values
                const filledData = Helper.fillChartDataWithZeroValues(topNData, metric)

                // const customId = sqlId ? sortedResults[0].sqlid : sortedResults[0].sqlhash
                // setCustomSqlID(filter && customId ? customId.toString() : '')
                setLoading(false);
                setTopNChartData(filledData)
                // @ts-ignore
                setGeneratedMetric(metric)
                setGeneratedCustomId(customSqlId)
                setGeneratedSQlId(sqlId)
                setGeneratedTagName(tagName)
                setGeneratedTagValue(tagValue)
                setStatementsApiData(sortedResults)
                setGeneratedInstance(selectedInstanceTarget)
            }

            if (!loading && !metric) {
                setLoading(true);
                chartApiDataResults = await fetchResults([
                    tagName === 'none'
                        ? SqlApi.fetchStatisticSql(buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType)
                        : SqlApi.fetchStatisticTagValue(tagName, buildApiQuery(timeRangeContext.timeRange, false), instanceId, instanceType)
                ])
                setStatementsApiData(chartApiDataResults[0])
                setGeneratedMetric(metric)
                setGeneratedCustomId(customSqlId)
                setGeneratedSQlId(sqlId)
                setGeneratedTagName(tagName)
                setGeneratedInstance(selectedInstanceTarget)
                setGeneratedTagValue(tagValue)
                setTopNChartData({})
                setLoading(false);
            }
        } catch (error: any) {
            const errorMessage = error.message || error.toString();
            showError('Failed to load Oracle statistics data', errorMessage);
            setStatementsApiData([])
            setTopNChartData({})
            setLoading(false);
        }
    }


    const isTime = metric.includes('time') || metric === 'duration'

    const timeChartSeries = useMemo<EChartTimeSeries[]>(() => Object.keys(topNChartData)
        .sort((first, second) => topNChartData[first].orderIndex - topNChartData[second].orderIndex)
        .map((key: string) => ({
        name: key,
        chartType: chart === 'column' || chart === 'bar' ? 'bar'
            : chart === 'area' ? 'area'
                : 'line',
        data: timeSeriesWithGranularity(topNChartData[key].values, metric) as EChartPoint[],
        color: key === 'Other SQL' ? OTHER_COLOUR_CODE : TARGET_COLOUR_CODES[topNChartData[key].orderIndex - 1],
        })), [topNChartData, chart, metric]);

    const timeChartAxis = useMemo(() => [{
        labels: true as const,
        name: `${stringFormatting(metric).replace(/_/gi, ' ')} ${Helper.getMetricFormatString(metric, true)}`,
        format: isTime ? 'time' as const : 'number' as const,
    }], [metric, isTime]);

    const timeChart = useMemo(() => (
        <TimeSeriesChart series={timeChartSeries}
                         tooltipType={isTime ? CHART_DATA_TYPE.TIME : CHART_DATA_TYPE.GENERIC}
                         legend={true} height={500} reverseStacks={false}
                         yAxis={timeChartAxis}/>
    ), [timeChartSeries, isTime, timeChartAxis]);

    useEffect(() => {
        updateUrlParams('metric', metric)
        updateUrlParams('chart', chart)
        updateUrlParams('tagName', tagName)
        updateUrlParams('topN', topN.toString())
        updateUrlParams('other', JSON.stringify(other))
        updateUrlParams('showSqlId', JSON.stringify(sqlId))
        updateUrlParams('customId', customSqlId, !customSqlId)
    }, [metric, chart, topN, other, sqlId, tagName, customSqlId])

    useEffect(() => {
        if (instanceId !== -1) {
            updateUrlParams('instance', instanceId.toString());
        }
    }, [instanceId]);

    const onInstanceSelect = (id: number) => {
        setInstanceId(id);
        setTagName('none')
        deleteUrlParam('tagName')
        deleteUrlParam('tagValue')
        const instanceType = availableInstances.find(instance => instance.id === id)?.type
        props.setInstanceType(instanceType)
        if (!filter) {
            setSQlId(instanceType === 'oracle')
        }
    };

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            load()
        }
    }
    const chartTitle = useMemo(() => {
        if (filter) {
            return statementsApiData.length ? `Statements ${generatedMetric && `By ${stringFormatting(generatedMetric).replace(/_/gi, ' ')}`} ${`for # ${statementsApiData[0].sqlhash}, ID ${statementsApiData[0].sqlid}`}` : ''
        }
        if (generatedTagValue) {
            return `Statements ${generatedMetric && `By ${stringFormatting(generatedMetric).replace(/_/gi, ' ')}`} ${generatedTagValue ? `for Tag Name: ${generatedTagName}, Tag Value: ${generatedTagValue}` : ''}`
        }
        return `Statements ${generatedMetric && `By ${stringFormatting(generatedMetric).replace(/_/gi, ' ')}`}`
    }, [generateId, statementsApiData])


    return <React.Fragment>
        <div className="row row-cols-1">
            {(loading) ?
                    <div className="loader chart" style={{ height: "auto" }}>
                        <div className="bar"/>
                    </div> : ''
            }
            <div id="statistics" className="show active" role="tabpanel" aria-labelledby="statements-tab">
                <div className="row">
                    <div className="card filter">
                        <div className="sql-filters d-flex flex-wrap align-items-end gap-3 filter-options-fields">
                            <div className="filter-field-wide">

                                <span className="required">Instance</span><br/>
                                <Dropdown
                                    value={instanceId || ''}
                                    onChange={(value) => onInstanceSelect(Number(value))}
                                    options={availableInstances.map(instance => ({ value: instance.id, label: instance.name }))}
                                    placeholder="Select instance"
                                    filter
                                    filterPlaceholder="Search instances"
                                    ariaLabel="Instance"
                                />
                            </div>
                            <div className="filter-field-wide">
                                <span className="required">
                                    <label>Metric</label>
                                </span>
                                <Dropdown
                                    value={metric}
                                    disabled={loading}
                                    ariaLabel="Select Metric"
                                    placeholder="Select metric"
                                    onChange={(value) => setMetric(String(value))}
                                    options={metricsList.map(metric => ({ value: metric, label: metric }))}
                                />
                            </div>
                            <div className="filter-field-wide">
                                <label>Chart</label>
                                <Dropdown
                                    value={chart}
                                    disabled={loading}
                                    ariaLabel="Select Chart Type"
                                    placeholder="Select chart type"
                                    onChange={(value) => setChart(String(value))}
                                    options={CHART_TYPE_OPTIONS}
                                />
                            </div>
                            <ConditionalRender if={!filter}>
                                <div className="filter-field-narrow">
                                    <span className="required">
                                        <label>Top N</label>
                                    </span>
                                    <input className="form-control"
                                           type='number'
                                           max={100}
                                           min={1}
                                           value={topN || ''}
                                           disabled={loading}
                                           onChange={(e) => {
                                               setTopN(parseInt(e.target.value));
                                           }}
                                           aria-label="Select Top N Statement to Show"/>
                                </div>
                            </ConditionalRender>
                            <ConditionalRender if={!tagValue && !filter}>
                                <div className="filter-field-wide">
                                        <span>
                                            <label>Tag Name</label>
                                        </span>
                                    <Dropdown
                                        value={tagName}
                                        disabled={loading}
                                        ariaLabel="Select Tag"
                                        onChange={(value) => setTagName(String(value))}
                                        options={[{ value: 'none', label: 'None' }, ...tagList.map(tag => ({ value: tag, label: tag }))]}
                                    />
                                </div>
                            </ConditionalRender>

                            <div>
                                <label htmlFor="stats-other-switch" data-tooltip-id="global-tooltip"
                                       data-tooltip-content='All other statements combined'>Other</label>
                                <div className='form-check form-switch'>
                                    <input
                                            type="checkbox"
                                            id="stats-other-switch"
                                            disabled={loading}
                                            className="form-check-input"
                                            onChange={() => {
                                                setOther(!other)
                                            }}
                                            checked={other}
                                    />
                                </div>
                            </div>

                            {instanceType === 'oracle' &&
                                <div>
                                    <label htmlFor="stats-show-sql-id-switch" className='text-nowrap'>Show SQL IDs</label>
                                    <div className='form-check form-switch'>
                                        <input
                                            type="checkbox"
                                            id="stats-show-sql-id-switch"
                                            disabled={loading}
                                            className="form-check-input"
                                            onChange={() => {
                                                setSQlId(!sqlId)
                                            }}
                                            checked={sqlId}
                                        />
                                    </div>
                                </div>
                            }

                            <div className="filter-field-narrow">
                                 <span className={`${filter ? "required" : ''}`}>
                                    <label className='text-nowrap'>{`${sqlId ? 'SQL ID' : 'SQL #'}`}</label>
                                 </span>
                                <input className="form-control"
                                       type='text'
                                       value={customSqlId || ''}
                                       disabled={loading}
                                       onKeyDown={handleKeyDown}
                                       onChange={(e) => {
                                           setCustomSqlID(e.target.value);
                                       }}/>
                            </div>

                            <div className="d-flex align-items-end ms-auto">
                                <button className="btn btn-success text-nowrap" disabled={!generateEnabled} onClick={load}><i
                                        className="fal fa-play fa-fw fa-sm"/><span>Generate</span></button>
                            </div>
                        </div>
                    </div>
                </div>

                {selectedInstanceTarget && statementsApiData && <div className="card">
                    <div className="card-header">
                        <i className="fal fa-scroll fa-fw" aria-hidden="true"/>
                        {chartTitle}
                        {/*set chart visible fa case in which is generated in minimised card version */}
                        <i className="collapse-toggle" role="button" onClick={() => setChartVisible(!chartVisible)}
                           data-bs-toggle="collapse"
                           data-bs-target="#collapseStatementsChart" aria-expanded="false"
                           aria-controls="collapseStatementsChart"/>
                    </div>
                    <ConditionalRender if={chartVisible}>
                        <div id="collapseStatementsChart" className="card-body collapse show">
                            {timeChart}
                        </div>
                    </ConditionalRender>
                </div>}
                <div className="col">
                    {selectedInstanceTarget && statementsApiData && generatedInstance &&
                        <OracleStatisticsTable aggregate={timeRangeContext.timeRange.interval}
                                               generateId={generateId}
                                               customSqlId={generatedCustomId}
                                               instance={generatedInstance} filter={filter} topN={topN}
                                               tagName={generatedTagName} tagValue={generatedTagValue}
                                               shwSqlID={generatedSqlId}
                                               metric={generatedMetric} chart={chart} statements={statementsApiData}/>}
                </div>

            </div>
        </div>
    </React.Fragment>
}
